import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesLinkTypesDeactivateRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-linktypes-deactivate',
	path: '/secure/admin/IssueLinkingDeActivate.jspa',
};
